/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Per-category cookie-consent decisions mirrored from Termly's consent state. `essential` is always-on and intentionally not stored. Booleans default false (deny) when absent.
 * @export
 * @interface CookieConsentCategories
 */
export interface CookieConsentCategories {
    /**
     * 
     * @type {boolean}
     * @memberof CookieConsentCategories
     */
    performance?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CookieConsentCategories
     */
    analytics?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CookieConsentCategories
     */
    advertising?: boolean;
    /**
     * Maps Termly's `social_networking` category.
     * @type {boolean}
     * @memberof CookieConsentCategories
     */
    socialNetworking?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CookieConsentCategories
     */
    unclassified?: boolean;
}

/**
 * Check if a given object implements the CookieConsentCategories interface.
 */
export function instanceOfCookieConsentCategories(value: object): value is CookieConsentCategories {
    return true;
}

export function CookieConsentCategoriesFromJSON(json: any): CookieConsentCategories {
    return CookieConsentCategoriesFromJSONTyped(json, false);
}

export function CookieConsentCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): CookieConsentCategories {
    if (json == null) {
        return json;
    }
    return {
        
        'performance': json['performance'] == null ? undefined : json['performance'],
        'analytics': json['analytics'] == null ? undefined : json['analytics'],
        'advertising': json['advertising'] == null ? undefined : json['advertising'],
        'socialNetworking': json['socialNetworking'] == null ? undefined : json['socialNetworking'],
        'unclassified': json['unclassified'] == null ? undefined : json['unclassified'],
    };
}

export function CookieConsentCategoriesToJSON(json: any): CookieConsentCategories {
    return CookieConsentCategoriesToJSONTyped(json, false);
}

export function CookieConsentCategoriesToJSONTyped(value?: CookieConsentCategories | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'performance': value['performance'],
        'analytics': value['analytics'],
        'advertising': value['advertising'],
        'socialNetworking': value['socialNetworking'],
        'unclassified': value['unclassified'],
    };
}

